import { useEffect, useState } from "react";
export var useIsChatOpen = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    useEffect(function () {
        var _a, _b;
        var unsubscribeOnOpen = (_a = window.chat) === null || _a === void 0 ? void 0 : _a.onOpen(function () { return setIsOpen(true); });
        var unsubscribeOnClose = (_b = window.chat) === null || _b === void 0 ? void 0 : _b.onClose(function () { return setIsOpen(false); });
        return function () {
            unsubscribeOnOpen();
            unsubscribeOnClose();
        };
    }, []);
    return isOpen;
};
